import { render, staticRenderFns } from "./OnTopicNoPicture.vue?vue&type=template&id=29e51d1a&"
import script from "./OnTopicNoPicture.vue?vue&type=script&lang=js&"
export * from "./OnTopicNoPicture.vue?vue&type=script&lang=js&"
import style0 from "./OnTopicNoPicture.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports